import {
    type SendCustomNotificationResponseType,
    type SendCustomNotificationRequestType
} from "./type";
import {
    request
} from "../request";

const sendCustomNotification = async (
    params: SendCustomNotificationRequestType
): Promise<SendCustomNotificationResponseType> => {
    return await request<SendCustomNotificationResponseType>(
        "/notification/sendCustomNotification",
        {
            body: JSON.stringify(params),
            method: "POST"
        }
    );
};
export default sendCustomNotification;
